module.exports = __webpack_public_path__ + "img/RECEIVE_MONEY.21200007.svg";